import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { OmniBarService } from "@tylertech/core-module";

@Injectable({ providedIn: "root" })
export class FormTitleService
{
    protected title: string;

    constructor(
        private readonly $titleService: Title,
        private readonly $omniBarService: OmniBarService)
    { }

    setTitle(title: string): void
    {
        if (!title || this.title === title)
        {
            return;
        }

        this.title = title;
        this.$omniBarService.title = title;
        // ?TODO - Should this be pushed down into omniBarService?
        this.$titleService.setTitle(title);
    }

    getTitle(): string
    {
        return this.title;
    }
}
